import { useEffect, useState } from 'react';
import config from '../../common/config';
import SvgMovie from '../../../components/SvgMovie';

import './styles/Digest14.less';

let timeoutDelayPlay: any = null;
let timeoutPlayText: any = null;
const Digest = ({ seq, play = false, onDataLoaded }: any) => {
  const [delayPlay, setDelayPlay] = useState(false);
  const [playText, setPlayText] = useState(false);
  const slide = config.slides[seq];

  useEffect(() => {
    if (timeoutDelayPlay) {
      clearTimeout(timeoutDelayPlay);
      timeoutDelayPlay = null;
    }
    if (timeoutPlayText) {
      clearTimeout(timeoutPlayText);
      timeoutPlayText = null;
    }

    if (play) {
      setTimeout(() => {
        setDelayPlay(true);
      }, 300);

      timeoutPlayText = setTimeout(() => {
        setPlayText(true);
      }, 4000);
    } else {
      // 恢复初始化状态
      setDelayPlay(false);
      setPlayText(false);
    }
  }, [play]);

  return (
    <div className={`digest-wrapper digest-wrapper-${seq}`}>
      <SvgMovie
        className="full-screen-svg"
        src={config.slides[seq].svgMovie}
        play={delayPlay}
        onDataLoaded={onDataLoaded}
      />
      <div className={`digest ${playText ? 'ani-fade-in' : ''}`}>
        <div className={`text-block`}>
          <SvgMovie
            className="svg-in-block"
            src={(slide.svgs as Array<string>)[0]}
            play={playText}
          />

          <div className="titles">
            <div className="title title-primary">是一套设计</div>
            <div className="title title-secondary">也是无限可能</div>
          </div>
          <div className="description">
            One design language
            传承统一的品牌视觉，让原先∞种学习成本降低为一种。自带流畅的人机交互让系统设计的精力放在产品本身。{' '}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Digest;
